/**
 * Creates layout system compatible action object for bookmark toggle
 *
 * @param {string} id Bookmark entity id
 * @param {('bookmark'|'unbookmark')} type
 * @returns {Object}
 */
export const makeBookmarkAction = (id, type) => ({
  target: {
    [`value_${type}`]: {
      id,
      type,
    },
  },
});
